const { REACT_APP_PRODUCT_SEARCH_LAMBDA_API, REACT_APP_PRODUCT_SEARCH_ACCESS_TOKEN } = process.env;

export const productDetailApi = (itemId, storeId, brandId) => {
  return {
    headers: {
      emcb_access_token: REACT_APP_PRODUCT_SEARCH_ACCESS_TOKEN,
    },
    apiUrl:
      REACT_APP_PRODUCT_SEARCH_LAMBDA_API +
      `/search/products/detail?item_id=${itemId}&biztp=${brandId}&store_id=${storeId}`,
  };
};
